const featureItems = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '创新的下拉滚动阅读模式，无需翻页点击，一路下滑畅读漫画，沉浸式阅读体验让追更更加流畅自然。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '实时更新',
    desc: '热门连载漫画每日实时同步更新，第一时间推送最新章节，让你永远走在追更最前线，不再错过任何精彩内容。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '完美适配电脑、平板和手机浏览器，无需下载APP即可在线看漫画。移动端网页版专为触摸操作优化，随时随地畅享阅读。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '海量资源',
    desc: '超过10万部漫画资源库，涵盖热血、恋爱、奇幻、悬疑等全品类，从经典完结到热门连载，51漫画在线满足你的所有阅读需求。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">为什么超过500万读者选择51漫画在线观看</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureItems.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-2xl p-6 md:p-8 text-center group hover:bg-primary-50 transition-colors duration-300">
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}